export default "__VITE_ASSET__CDPA6qYG__"